import Box from "../components/box";
import Btn from "../components/btn";
import h from "../core/createElement";
import Modal from "../core/modalEngine";

function GenericConfirm({ hide, cancel, title, text, confirm, showCancel = true, textConfirm = "Confirmar" }) {
    const
        on_cancel = () => {
            hide();
            cancel && cancel();
        },
        on_confirm = () => {
            hide();
            confirm && confirm();
        };

    return (
        <Box title={title} buttons={<Btn icon="assets/image/x_white.svg" onClick={on_cancel} color="red" />}>
            <section class="flex-column p6px">
                <span class="text-confirm">{text}</span>

                <div class="bottom-btns">
                    {showCancel ? <Btn title="Cancelar" color="red" onClick={on_cancel} /> : ""}
                    <Btn title={textConfirm} color="green" onClick={on_confirm} />
                </div>
            </section>
        </Box>
    )
};

const GenericConfirmModal = new Modal(GenericConfirm);

export default GenericConfirmModal;